import { useSelector } from 'react-redux';
import { Container } from 'react-bootstrap';
import Header from '../ui/Header';
import Footer from '../ui/Footer';
import LoaderSpinner from '../ui/LoaderSpinner';
import MessageErrorModal from '../ui/Modals/MessageErrorModal';
import IdleTimerModal from '../ui/Modals/IdleTimerModal';

function MainLayout({ children }) {
  const {
    idleTimer,
    isLoading,
    errorMessage,
    callAgency,
  } = useSelector((state) => state.majestic);

  return (
    <>
      <div className="vh-100">
        <Container fluid className="h-100 d-flex flex-column">
          <Header />
          <main className="app_content flex-grow-1">
            {children}
          </main>
          <Footer />
        </Container>
        {errorMessage !== '' && (
          <MessageErrorModal message={errorMessage} callAgency={callAgency} />
        )}
        {idleTimer.showModal && <IdleTimerModal />}
      </div>
      {isLoading && <LoaderSpinner />}
    </>
  );
}

export default MainLayout;
